import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import CTA from "@/components/CTA";
import Seo from "@/components/Seo";
import { blogPosts } from "@/data";

const InsightsPage = () => (
  <main className="page">
    <Seo
      title="Travel Insights & Perspectives"
      path="/insights"
      description="Ideas, trends, and stories from the HI Tours Group teams, shaping the future of travel and tourism. Read our latest articles on leisure, outbound, aviation, and market trends."
    />
    <PageHero eyebrow="Our Insights" title="Travel Insights & Perspectives" subtitle="Ideas, trends, and stories from our teams, shaping the future of travel and tourism." />
    <section className="section">
      <div className="container">
        <h2 className="blog-section-title">Latest articles</h2>
        <div className="blog-grid">
          {blogPosts.map((p) => (
            <Link className="blog-card reveal" key={p.slug} to={`/insights/${p.slug}`} data-testid={`insight-card-${p.slug}`}>
              <div className="blog-card__media">
                <img src={p.cover} alt={p.title} loading="lazy" />
                <span className="blog-card__cat">{p.category}</span>
              </div>
              <div className="blog-card__body">
                <h3 className="blog-card__title">{p.title}</h3>
                <p className="blog-card__excerpt">{p.excerpt}</p>
                <span className="blog-card__link">Read article
                  <span className="icon-plus icon-plus--sm">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" /></svg>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
    <CTA />
  </main>
);

export default InsightsPage;
